<template>
  <div class="bg-white px-6 pt-24 sm:pt-32 lg:px-8">
    <div class="mx-auto max-w-2xl text-center">
      <p class="text-base font-semibold leading-7 text-primary">Srovnávejte zboží</p>
      <h2 class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">Srovnávejte zboží jednoduše!</h2>
      <p class="mt-6 text-lg leading-8 text-gray-600">Tisíce produktů na jednom místě</p>
      <div class="mt-8">
        <Button @click="handleButtonClick()" label="Zobrazit produkty" class="px-6 py-3 text-base font-semibold leading-6 text-white bg-primary" />
      </div>
    </div>
    <div class="w-full h-full mx-auto text-center py-24 sm:py-32">
      <h2 class="text-2xl font-bold">Najdete u nás:</h2>
      <div class="flex mx-auto justify-center gap-x-8 align-middle items-center">
        <div class="">
          <img loading="lazy" src="/images/eshops/pompo.svg" alt="eshop1" class="w-full max-h-[112px] object-contain" />
        </div>
        <div class="">
          <img loading="lazy" src="/images/eshops/triola.svg" alt="eshop1" class="w-full max-h-[112px] object-contain" />
        </div>
        <div class="">
          <img loading="lazy" src="/images/eshops/eleven.svg" alt="eshop1" class="w-full max-h-[112px] object-contain" />
        </div>
        <div class="hidden md:block">
          <img loading="lazy" src="/images/eshops/dekorhome.svg" alt="eshop1" class="w-full max-h-[112px] object-contain" />
        </div>
        <div class="hidden md:block">
          <img loading="lazy" src="/images/eshops/eandilek.svg" alt="eshop1" class="w-full max-h-[112px] object-contain" />
        </div>
      </div>
      <div class="xl:w-full mx-2 lg:mx-auto -mt-1 lg:-mt-1.5"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import Button from 'primevue/button';
import { useRouter } from 'vue-router';
import { PUBLIC_ROUTES } from '@/enums/PublicRoutesEnum';

const router = useRouter();
const handleButtonClick = () => {
  router.push({ name: PUBLIC_ROUTES.PRODUCTS });
};
</script>
